import React from "react";
import { TableSkeletonRow } from "./TableSkeletonRow";
import {dashboardColumns} from "./dashboardTableConfig.ts";

export const DashboardSkeletonTable: React.FC = () => {
    return (
        <div className="hidden md:block border border-gray-100 rounded-lg shadow-sm overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full table-fixed">
                    <thead className="bg-gray-100">
                    <tr>
                        {dashboardColumns.map((col, idx) => (
                            <th
                                key={idx}
                                className={`px-1 py-2 text-xs font-semibold text-gray-600 tracking-wider border-b border-gray-100 ${
                                    col.align === "center" ? "text-center" : "text-left"
                                } ${col.showOn ? `hidden ${col.showOn}:table-cell` : ""}`}
                                style={{ width: col.width }}
                            >
                                {col.label}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-100">
                    {Array.from({ length: 10 }).map((_, i) => (
                        <TableSkeletonRow key={i} />
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};